import React from 'react';
import { Menu } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { OrganizationSwitcher, SignInButton, SignedOut, SignedIn, UserButton } from '@clerk/clerk-react';
const StyledMenu = styled(Menu) `
  height: 100%;
`;
const BillingIcon = () => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", width: "16", height: "16" },
        React.createElement("path", { d: "M20 4H4C2.9 4 2 4.9 2 6v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM20 8H4V6h16v2zm0 10H4v-6h16v6zm-10-4h-2v2h2v-2zm4 0h-2v2h2v-2z" })));
};
const UserMenu = () => {
    const navigate = useNavigate();
    return React.createElement(React.Fragment, null,
        React.createElement("div", { style: { paddingRight: '0.5rem', borderRight: '1px solid #e0e0e0', marginRight: '1rem' } },
            React.createElement(OrganizationSwitcher, { afterSelectOrganizationUrl: () => {
                    //reload the page
                    setTimeout(() => {
                        window.location.reload();
                    }, 200);
                    return window.location.href;
                } })),
        React.createElement(SignedOut, null,
            React.createElement(SignInButton, null)),
        React.createElement(SignedIn, null,
            React.createElement(UserButton, null,
                React.createElement(UserButton.MenuItems, null,
                    React.createElement(UserButton.Action, { label: "Billing", labelIcon: React.createElement(BillingIcon, null), onClick: () => navigate('/billing') })))));
};
export default UserMenu;
